export const DO_RESETPASS_FAIL = 'DO_RESETPASS_FAIL';
export const DO_CREATE_PASSWORD= 'DO_CREATE_PASSWORD';
export const DO_RESETPASS_ACTION = 'DO_RESETPASS_ACTION';
export const DO_RESETPASS_SUCCESS = 'DO_RESETPASS_SUCCESS';
